import {useLottie} from "lottie-react";
import animationData from 'src/assets/animations/splash-logo';
import Grid from "@mui/material/Grid/Grid";
import {useEffect} from "react";


const Splash = ({setIsAnimating}) => {


    const options = {
        animationData,
        loop: false,
        autoplay: true,
    };

    const {View, animationItem} = useLottie(options);


    useEffect(() => {
        if (animationItem) {
            animationItem.addEventListener("complete", () => {
                setIsAnimating(false)
                // Your logic here
            });
        }
    }, [animationItem]);


    return (
        <Grid container alignItems={"center"} justifyContent={"center"}
              style={{width: "100vw", height: "100vh", position: "fixed", top: 0, zIndex: 110, background: "white"}}>
            {View}
        </Grid>
    )
}

export default Splash;
